import { render, staticRenderFns } from "./ViewToolbar.vue?vue&type=template&id=b36fbb22&scoped=true&"
import script from "./ViewToolbar.vue?vue&type=script&lang=js&"
export * from "./ViewToolbar.vue?vue&type=script&lang=js&"
import style0 from "./ViewToolbar.vue?vue&type=style&index=0&id=b36fbb22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36fbb22",
  null
  
)

export default component.exports